import axios from "axios";
import { toast } from "react-toastify";

// export const createItem = (itemData) => {
//   // Use FormData to handle file uploads
//   const formData = new FormData();
//   Object.keys(itemData).forEach((key) => {
//     formData.append(key, itemData[key]);
//   });
//   console.log(itemData, "itemDataitemData");

//   return axios.post(`${process.env.REACT_APP_API_URL}item/items`, itemData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };

export const createItem = async (formDataSend) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}item/items`,
    formDataSend,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const getItems = () => {
  return axios.get(`${process.env.REACT_APP_API_URL}item/items`);
};

export const getItemById = (id) => {
  return axios.get(`${process.env.REACT_APP_API_URL}item/items/${id}`);
};

export const updateItem = (id, itemData) => {
  // const formData = new FormData();
  // Object.keys(itemData).forEach((key) => {
  //   formData.append(key, itemData[key]);
  // });

  return axios.patch(
    `${process.env.REACT_APP_API_URL}item/items/${id}`,
    itemData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// export const deleteItem = (id) => {
//   return axios.delete(`${API_URL}/items/${id}`);
// };
export const handleDelete = async (event, id) => {
  event.stopPropagation(); // Prevent click on card itself when clicking delete icon

  const confirmDelete = window.confirm(
    "Are you sure you want to delete this item?"
  );
  if (confirmDelete) {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}item/items/${id}`);
      toast.success("Item deleted successfully");
    } catch (error) {
      console.error("Failed to delete item:", error);
      toast.error("Failed to delete item");
    }
  }
};
